"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_ABANDONED = exports.PLUGIN_IDENTIFIER = exports.defaultRetryDelay = exports.defaultRetries = void 0;
exports.defaultRetries = 3;
exports.defaultRetryDelay = 1000;
exports.PLUGIN_IDENTIFIER = '[ Module Federation RetryPlugin ]';
exports.ERROR_ABANDONED = 'The request failed and has now been abandoned';
